import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMacIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "80%",
	height: "100%",
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M37.4199 39C35.7599 41.48 33.9999 43.9 31.3199 43.94C28.6399 44 27.7799 42.36 24.7399 42.36C21.6799 42.36 20.7399 43.9 18.1999 44C15.5799 44.1 13.5999 41.36 11.9199 38.94C8.49994 34 5.87994 24.9 9.39994 18.78C11.1399 15.74 14.2599 13.82 17.6399 13.76C20.1999 13.72 22.6399 15.5 24.2199 15.5C25.7799 15.5 28.7399 13.36 31.8399 13.68C33.1399 13.74 36.7799 14.2 39.1199 17.64C38.9399 17.76 34.7799 20.2 34.8199 25.26C34.8799 31.3 40.1199 33.32 40.1799 33.34C40.1199 33.48 39.3399 36.22 37.4199 39ZM25.9999 7C27.4599 5.34 29.8799 4.08 31.8799 4C32.1399 6.34 31.1999 8.7 29.7999 10.38C28.4199 12.08 26.1399 13.4 23.8999 13.22C23.5999 10.92 24.7199 8.52 25.9999 7Z" })]
});
const ForwardRef = forwardRef(SvgMacIcon);
export { ForwardRef as ReactComponent };
